import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SmoStoricoModifiche } from '../objects/smoStoricoModifiche';
import { AppConfigService } from './app-config.service';


@Injectable({
  providedIn: 'root'
})
export class ModificationHistoryService{
  endpoint: string;
  apiName:string='ModifyHistory';

  constructor( protected http: HttpClient, protected appConfigService:AppConfigService)
  {
    this.http=http;
    this.endpoint = appConfigService.apiBaseUrl;
  }

  read(serialNumberMs:number): Observable<SmoStoricoModifiche[]> {
    //this.loading = true;

    console.log(this.apiName);
    return this.http.get<SmoStoricoModifiche[]>(`${this.endpoint}/${this.apiName}?serialMS=${serialNumberMs}`);
  }
}